import React, { useState, useRef, useEffect } from 'react';
import { handleApiRequest } from '../api';

const ContactForm = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    error: '',
  });

  const formRef = useRef(null);

  const toggleForm = () => setIsOpen((prev) => !prev);

  // Close on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (formRef.current && !formRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const sendData = async (e) => {
    e.preventDefault();
    console.log('Clicked');
    const data = formData;
    let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(data.email)) {
      setFormData({ ...data, error: 'Invalid Email' });
      return;
    }
    const { error, ...responseData } = data;
    const response = handleApiRequest('getintouch', 'post', responseData);
    console.log('response', response);
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-40 transition-opacity duration-300"></div>
      )}

      <div
        className={`fixed top-[23%] right-0 h-content w-full sm:w-[400px] bg-white shadow-2xl transform transition-transform duration-500 z-50 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        ref={formRef}
      >
        <div className="p-6">
          <div className="flex justify-between items-start">
            <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
            <button
              onClick={toggleForm}
              className="text-gray-500 hover:text-gray-800 text-xl"
            >
              ✕
            </button>
          </div>

          <form className="space-y-4" onSubmit={sendData}>
            <div>
              <label className="block text-sm font-medium">Name</label>
              <input
                type="text"
                className="w-full border rounded px-3 py-2"
                placeholder="Your name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Email</label>
              <input
                type="email"
                className="w-full border rounded px-3 py-2"
                placeholder="you@example.com"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Message</label>
              <textarea
                className="w-full border rounded px-3 py-2"
                placeholder="Your message"
                rows="4"
                value={formData.message}
                onChange={(e) =>
                  setFormData({ ...formData, message: e.target.value })
                }
              ></textarea>
            </div>
            <button
              type="submit"
              className="bg-[#3498db] hover:bg-[#3498dbcc] text-white px-4 py-2 rounded "
            >
              Submit
            </button>
          </form>
          <div className="text-red-500 mt-2">{formData.error}</div>
        </div>
      </div>

      {!isOpen && (
        <div className="fixed top-1/2 right-0 transform -translate-y-1/2 z-30 animate-bounceRight">
          <button
            onClick={toggleForm}
            className="bg-[#3498db] hover:bg-[#3498dbcc] transition-all duration-300 text-white p-4 rounded-l-xl shadow-lg"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
          </button>
        </div>
      )}
    </>
  );
};

export default ContactForm;
